import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-jein-dialog',
    standalone: false,
    templateUrl: './jein-dialog.component.html',
    styleUrls: ['./jein-dialog.component.scss'],
})
export class JeinDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<JeinDialogComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    close(jein: boolean): void {
        this.dialogRef.close(jein);
    }
}
